<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioAnio($event)"
  />

  <app-filters filtros
    [name]="'filtros.pers' | translate" 
    [array]="perspectives"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="todasPer"
    (eventClick)="cambioPer($event)"
  />

  <app-filters filtros
    [name]="'filtros.res' | translate" 
    [array]="responsables"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="selAll"
    (eventClick)="cambioLider($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}" class="iconoMen"
    (click)="borrarFiltros()" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
    <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="contenidoClass">
    @if (tabOgraf){
      <div class="zonaTabla">
        <app-contenedor-elementos [header]="{
          title: 'gestion.seguimiento.indicadores.tituloZon1' | translate,
        }">

          <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menutabla">more_vert</mat-icon>
          <mat-menu #menutabla="matMenu">
            <div [ngClass]="todasPer? 'w3-disabled':''">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="cambiarGraf()">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{ 'gestion.seguimiento.indicadores.verGraf' | translate }}</span>
              </button>
            </div>
            <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{ 'gestion.seguimiento.indicadores.expor' | translate }}</span>
            </button>
          </mat-menu>

          <div body class="tabla">
            @if (viewTablero) {
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    <th style="background-color: white;"></th>
                    <th style="background-color: white;"></th>
                    @if(verCodigo) {
                      <th style="background-color: white;"></th>
                    }
                    <th class="sticky-column" style="background-color: white;"></th>
                    @for(an of aniosDisponibles; track an.id) {
                      @for(mes of an.series; track mes.id) {
                        @if(mes.check) {
                          <th [colSpan]="2">
                            {{mes.periodo}}
                          </th>
                        }
                      }
                    }
                  </tr>
                  <tr>
                    <th>{{ 'gestion.seguimiento.indicadores.titTab1' | translate }}</th>
                    <th>{{ 'gestion.seguimiento.indicadores.titTab2' | translate }}</th>
                    @if(verCodigo) {
                      <th class="anchosCodigo">
                        {{ 'gestion.seguimiento.indicadores.titTab9' | translate }}</th>
                    }
                    <th class="sticky-column">
                      {{ 'gestion.seguimiento.indicadores.titTab3' | translate }}</th>
                    @for(an of aniosDisponibles; track an.id) {
                      @for(mes of an.series; track mes.id) {
                        @if(mes.check) {
                          <th style="font-weight: normal; background-color: #E6E7E8;">{{
                            'gestion.seguimiento.indicadores.titTab4' | translate }}</th>
                          <th style="font-weight: normal; background-color: #E6E7E8;">{{
                            'gestion.seguimiento.indicadores.titTab5' | translate }}</th>
                        }
                      }
                    }
                  </tr>
                </thead>
                <tbody>
                  @for(fila of filasTabla; track fila.ind.id; let i = $index) {
                    <tr>
                      <td [ngClass]="fila.borderClass" class="anchos textoOverFlow"
                      [matTooltip]="fila.per" [appOverflowTooltip]="fila.per">
                        {{fila.per}}
                      </td>
                      <td [ngClass]="fila.borderClass" class="anchos textoOverFlow"
                      [matTooltip]="fila.obj" [appOverflowTooltip]="fila.obj">
                        {{fila.obj}}
                      </td>
                      <td [ngClass]="fila.borderClass" class="anchos textoOverFlow sticky-column"
                      [matTooltip]="fila.ind.nombre" [appOverflowTooltip]="fila.ind.nombre">
                        {{fila.ind.nombre}}
                      </td>

                      @for(celda of fila.celdas; track celda.periodo) {
                        <td [ngClass]="fila.borderClass" class="borderAllLow w3-center">
                          @if(celda.meta !== '') {
                            {{celda.meta}}
                          } @else {
                            <br>
                          }
                        </td>
                        @if(celda.meta === '') {
                          <td class="w3-center">
                            <br>
                          </td>
                        }@else if(celda.meta !== '') {
                          <ng-container *appRoles="permisos.SEGUIMIENTO">
                            <td class="w3-center" [ngClass]="celda.borde"
                            (dblclick)="editar(celda.periodo, fila.ind)"
                            style="cursor: pointer; background-color: #E0E0E0;">
                                {{ celda.esNull ? '-' : celda.real }}
                            </td>
                          </ng-container>
                          <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                            <td class="w3-center" [ngClass]="celda.borde"
                            style="cursor: pointer; background-color: #E0E0E0;">
                              {{ celda.esNull ? '-' : celda.real }}
                            </td>
                          </ng-container>
                        }
                      }
                    </tr>
                  }
                </tbody>
              </table>
            }@else {
              <app-skeleton-table [columnas]="12" [filas]="12" />
            }
          </div>
          
        </app-contenedor-elementos>
      </div>
      <div class="zonaGraf">
        <app-contenedor-elementos [header]="{
          title: 'gestion.seguimiento.indicadores.tituloZon3' | translate,
          subtitles: [{text: subtitulo}]
        }">
          <div body class="grafica">
            @if (viewTablero) {
              <app-graficador
                [etiquetas]="true"
                [data]="treemap"
                [labels]="etiquetas"
                [type]="tipoGraf.HEATMAP"
                [axisX]="''"
                [axisY]="['']"
                [zona]="0"
                [colors]="colorScheme_balance"
                [formatEtiquetas]="false"
                [animations]="true"
                [speedAnimations]="500"
                [legend]="{enabled: false, position: 'bottom'}"
                [hetamapValor]="true"
                (eventClick)="selectIndicadores($event)"
              />
            }@else{
              <app-skeleton-grafica [barras]="3" , [leyendas]="2" />
            }
          </div>
        </app-contenedor-elementos>
      </div>
    }@else {
      <div class="zonaGraficas">
        <app-esqueleto-tableros class="zonaHeader">
          <div titulo class="encabezadosSeparacion"
            [matTooltip]="'gestion.seguimiento.indicadores.tituloZon2' | translate"
            [appOverflowTooltip]="'gestion.seguimiento.indicadores.tituloZon2' | translate">
            <span class="headerCintilla2">{{'gestion.seguimiento.indicadores.tituloZon2' | translate}}</span>
          </div>

          <app-filters filtros
            [name]="'gestion.seguimiento.indicadores.ind' | translate" 
            [array]="graficas_lineales"
            [typeFilter]="Filters.PERSPECTIVES"
            [click]="false"
            (eventClick)="selecGrafLin($event)"
          />

          <div borrador [matTooltip]="'gestion.seguimiento.indicadores.tooltip1' | translate"
            (click)="cambiarGraf()">
            <mat-icon borrador class="iconoMen" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
          </div>
        </app-esqueleto-tableros>

        <div class="zonaGrafic">
          @for (graf of graficas_lineales; track graf.id; let i =$index) {
            @if(graf.labels.length != 0 && graf.check){
              <app-contenedor-elementos [header]="{
                title: graf.name
              }" class="graficaAlto">

                <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
                  [matMenuTriggerFor]="menutabla">more_vert</mat-icon>
                <mat-menu #menutabla="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="quitarGrafLin(i)">
                    <mat-icon [ngStyle]="{'color':'gray'}">close</mat-icon>
                    <span>{{ 'gestion.seguimiento.indicadores.option1' | translate }}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarImg(i,graf)">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{ 'gestion.seguimiento.indicadores.option2' | translate }}</span>
                  </button>
                </mat-menu>

                <div body style="width: 100%; height: 100%;">
                  <app-graficador
                    [etiquetas]="false"
                    [data]="graf.series"
                    [labels]="graf.labels"
                    [type]="tipoGraf.LINE"
                    [axisX]="'Periodo'"
                    [axisY]="['']"
                    [zona]="i+1"
                    [colors]="colors_lineal"
                    [formatEtiquetas]="false"
                    [animations]="false"
                    [legend]="{enabled: true, position: 'bottom'}"
                  />
                </div>

              </app-contenedor-elementos>
            }
          }
        </div>
      </div>
    }
  </div>

</app-esqueleto-tableros>